import { CookieScriptManage } from '@amf/shared/components/utils/CookieScript';
import Container from '@amf/shared/components/layout/Container';
import { useTranslate } from '@tolgee/react';
import { GetServerSideProps } from 'next';
import { getNavigation, getPartners, NavigationProps } from '@amf/shared/utils/navigation';
import { getLanguageLocale } from '@amf/shared/utils/languages';

function CookiesPage() {
  const { t } = useTranslate();
  return (
    <Container>
      <h1>{t('cookies.title')}</h1>
      <CookieScriptManage cookieKey={process.env.NEXT_PUBLIC_COOKIE_SCRIPT_KEY} />
    </Container>
  );
}

export default CookiesPage;

export const getServerSideProps =
  (): GetServerSideProps<NavigationProps> =>
  async ({ locale, res }) => {
    res.setHeader('Cache-Control', 'private');

    if (!process.env.NEXT_PUBLIC_COOKIE_SCRIPT_KEY) {
      return { notFound: true };
    }

    return {
      props: {
        navigation: await getNavigation(getLanguageLocale(locale!)),
        partners: await getPartners(),
      },
    };
  };
